import React, { useContext, useEffect } from "react";
import StyleContext from "../../contexts/StyleContext";
import "./ToggleSwitch.scss";

const ToggleSwitch = () => {
  const { isDark, changeTheme } = useContext(StyleContext);

  return (
    <label className="switch" htmlFor="theme-toggle" aria-label="Toggle dark mode">
      <input
        id="theme-toggle"
        type="checkbox"
        aria-label="Dark Mode Toggle" 
        aria-checked={isDark}
        checked={isDark}
        onChange={changeTheme}
      />
      <span className="slider round">
        <span className="slider-icon sun-icon">☀️</span>
        <span className="slider-icon moon-icon">🌙</span>
      </span>
    </label>
  );
};
export default ToggleSwitch;
